module.exports = __webpack_public_path__ + "static/media/bj.22430301.svg";